import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Global keyboard shortcuts for NovaMuhasebe.
 *
 * Shortcuts:
 *  Ctrl+1 → Dashboard        Ctrl+2 → Stok       Ctrl+3 → Cari
 *  Ctrl+4 → Fatura            Ctrl+5 → Kasa       Ctrl+6 → Banka
 *  F12    → POS (tam ekran)
 *  Ctrl+N → Yeni kayıt (genel, her modül kendi handler'ını overrides edebilir)
 *  Alt+F4 → (tarayıcıya bırak)
 */
export function useGlobalKeyboardShortcuts() {
  const navigate = useNavigate()

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // F12 → POS
      if (e.key === 'F12') {
        e.preventDefault()
        navigate('/pos')
        return
      }

      if (!e.ctrlKey && !e.metaKey) return

      switch (e.key) {
        case '1':
          e.preventDefault()
          navigate('/')
          break
        case '2':
          e.preventDefault()
          navigate('/stok')
          break
        case '3':
          e.preventDefault()
          navigate('/cari')
          break
        case '4':
          e.preventDefault()
          navigate('/fatura')
          break
        case '5':
          e.preventDefault()
          navigate('/kasa')
          break
        case '6':
          e.preventDefault()
          navigate('/banka')
          break
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [navigate])
}

/**
 * Page-level shortcut: Ctrl+N → create new record
 */
export function useNewRecordShortcut(onNew: () => void) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'n') {
        // Don't trigger when an input/textarea is focused
        const tag = (e.target as HTMLElement).tagName
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return
        e.preventDefault()
        onNew()
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onNew])
}

/**
 * Ctrl+S → save in form pages
 */
export function useSaveShortcut(onSave: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 's') {
        e.preventDefault()
        onSave()
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onSave, enabled])
}
